import { FilterCompanyVendorsWebPage, getCompanyVendorsWebPage } from 'commons/service/bank/companyDetails'
import { CompanyVendorsWebPage } from 'commons/types/DTO/bank/companyDetails/vendor'
import { WriteHook, useMutationManager } from 'state-manager'

export const useFilterCompanyVendorsWebPage: WriteHook<FilterCompanyVendorsWebPage, CompanyVendorsWebPage> = (opts) =>
  useMutationManager(getCompanyVendorsWebPage, opts)
